import React from "react";

import seConfigure from "../../images/se-configure.png";
import seDeploy from "../../images/se-iPC.jpg";
import sePLC from "../../images/se-plc.png";
import seVijeo from "../../images/se-vijeo.png";
import SEVIJEO from "../../images/se_iPC2.jpg";
import MOXA from "../../images/Moxa_IMG.png";
import Fortigate from "../../images/Fortigate.png";
import connexium from "../../images/connexium.png";
import batteryImage from "../../images/BESS-cabinate.0c3c0b2a.png";
import ONLOGIC from "../../images/OnLogic.png";
import embLabels from "../../config/emb-labels-en.json";
import isTouchDevice from "../SE-Component/Tooltip";
import Tooltip from "../../utils/Tooltip";
import { getProjectTypeValue } from "../../utils/project";
import { DAAS_ANSI, MGAAS_ANSI } from "../../utils/application.constants";
import { useSelector } from "react-redux";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
import { useAtom } from "jotai";
import { defaultProject, projectAtomList } from "../../atoms";
import ApiSession from "../../api/ApiSession";
import { SeIcon, SeLink } from "@se/web-ui-react";
import { sendCallToActionEvent } from "../../utils/gaHelper";
import env from "../../env";
import linkIcon from "../../images/external-link.svg";
const apiSession = new ApiSession();
const Services = ({
  UserScope,
  gridSetting,
  unlockDeploy,
  siteType,
  bessControllerAvailable,
  masterBessControllerAvailable,
  clientType,
  architectureType,
  keyExpert,
  keyOperations,
  emaSiteStatus,
  versions,
  createSiteInEMA,
  deleteSiteInEMA,
  setDownloadProgram,
  downloadIpcFile,
  downloadOnLogicFile,
  handleSerialNoPopUp,
  downloadHMI,
  downloadMOXA,
  downloadFortiGate,
  downloadCONNEXIUM,
  downloadOnLogic,
  downloadBESSController,
  emaSiteId,
  deploymentStatus,
  projectKind,
  currentProject,
  openProgramModel,
  projectId,
  setUploadedPackage,
  setOpenUploadFile,
  setShowConfig,
  emoDocList,
  gatewayType,
  latestVersionMap,
  setAlertMessage,
  navigateToEMOM
}) => {
  const projectProgressStatus = currentProject?.projectStatus;
  const [toolTipData, setToolTiData] = useAtom(projectAtomList);
  const projectTypeValue = useProjectTypeValue();
  const updatesOnInformationpage = sessionStorage.getItem("informationUpdateAvailable");
  const updatesOnDerspage = sessionStorage.getItem("dersUpdateAvailable");
  const updatesOnSystempage = sessionStorage.getItem("systemUpdatesAvailable");
  const updatesAvailable = emaSiteId && projectTypeValue === "NMGaaS ETO" && (updatesOnInformationpage === "true" || updatesOnDerspage === "true" || updatesOnSystempage === "true");
  const checkProgramFiles = async (type, checkUpload) => {
    sendCallToActionEvent('Projects',type==='IPC'?'Download Configuration':'Download Program','Deploy');
    setOpenUploadFile({ isOpen: false, packageType: "" });
    if(type === "IPC" || type === "PLC"){
    try {
      const isUploadFileAvailable = await apiSession.getProgramPackages(
        projectId,
        type
      );

      if (isUploadFileAvailable) {
        setUploadedPackage(isUploadFileAvailable);

        if (checkUpload) {
          setDownloadProgram((prev) => {
            return { isOpen: true, packageType: type };
          });
        }
      }
    } catch (error) {
      console.log(error);
      setOpenUploadFile({ isOpen: true, packageType: type });
      setUploadedPackage(null);

      if (checkUpload) {
        handleTypeSpecificActions(type);
      }

      setDownloadProgram({ isOpen: false, packageType: "" });
    }
  }else{
    handleTypeSpecificActions(type);
  }
  };

  const handleTypeSpecificActions = (type) => {
    switch (type) {
      case "PLC":
        handleSerialNoPopUp("PLC");
        break;
      case "HMI":
        downloadHMI();
        break;
      case "MOXA":
        downloadMOXA();
        break;
      case "FortiGate":
        downloadFortiGate();
        break;
      case "CONNEXIUM":
        downloadCONNEXIUM();
        break;
      case "IPC":
         handleSerialNoPopUp("IPC");
        // downloadIpcFile();
        break;
      default:
        break;
    }
    setOpenUploadFile({ isOpen: false, packageType: type });
  };

  const enableButton = () => {
    const {
      generatePLC,
      ipc,
      createEMASite,
      downloadHMI,
      downloadPLC,
      downloadMOXA = true,
      downloadFortiGate = true,
      downloadCONNEXIUM = true,
    } = UserScope.access;
    const { licenseMatched } = deploymentStatus;
    if (
      clientType === "A2E_PROJECT" &&
      (projectProgressStatus?.projectStatus === "COMPLETED" ||
        projectProgressStatus?.projectStatus === "COMPLETED_AND_SEND") &&
      (licenseMatched === "MATCHED" || unlockDeploy)
    ) {
      if (generatePLC && ipc && createEMASite) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        (projectProgressStatus?.projectStatus === "COMPLETED" ||
          projectProgressStatus?.projectStatus === "COMPLETED_AND_SEND") &&
        generatePLC &&
        ipc &&
        downloadHMI &&
        downloadPLC &&
        (licenseMatched === "MATCHED" || unlockDeploy) &&
        downloadMOXA &&
        downloadFortiGate &&
        downloadCONNEXIUM
      ) {
        return false;
      } else {
        return true;
      }
    }
  };
  const { licenseMatched } = deploymentStatus;
  const isConfigureEmaServicesDisabled =
    UserScope?.access?.createEMASite === undefined ? true : enableButton();
  const isConfigureUseCasesDisabled = !emaSiteId || isConfigureEmaServicesDisabled;
  
const parseTooltipContent = () => {
  const tooltipData = toolTipData?.tooltipData?.hmiPackageToolTip?.data || ""
  if (!tooltipData) return null;
  
  return tooltipData.split('<br></br>').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < tooltipData.split('<br></br>').length - 1 && <br />}
    </React.Fragment>
  ));
};

  return (
    <>
      <div className="row justify-content-center mb-1 mt-1">
        <div className="col-sm-12 mb-2 se-life-green se-font-14px-bold mt-2 pl-0">
          EcoStruxure Microgrid Configuration
        </div>

        <div className="col-sm-12 pl-0">
          <div className="row justify-content-center deploy-row-equal-height">
            {gridSetting.remoteMonitoringControl && (
              <div className={`col-md-3  padding-left remove-padding-right mt-2 mb-2`}>
                <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                  <div className="col-md-12 labelCircle-contanier">
                    <img
                      src={seConfigure}
                      className="img-fluid img-height-deploy deploy-image-cover"
                      alt="Configure EMA"
                    />
                    <span className="labelCircle-deploy">
                      {licenseMatched === "MATCHED" ||
                      unlockDeploy ||
                      ([
                        embLabels.ISLANDABLE,
                        embLabels.GRID_CONNECTED,
                        embLabels.GRID_CONNECTED_GSX,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : [
                            embLabels.PV_HYBRIDIZATION,
                            embLabels.ISLANDABLE_GSX,
                            embLabels.GENSET_PVBESS_A2E,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : false) ? (
                        <se-icon size="medium">action_lock_off</se-icon>
                      ) : (
                        <se-icon size="medium">action_lock_on</se-icon>
                      )}
                    </span>
                  </div>

                  <div className={`col-md-12 pt-1 deploy-card-title-block ${projectTypeValue === "NMGaaS ETO" && emaSiteId ? "min-height-61" : ""}`}>
                    <span className="font-block-header">
                      {siteType === embLabels.PV_HYBRIDIZATION ||
                      siteType === embLabels.GENSET_PVBESS_A2E ||
                      (siteType === embLabels.ISLANDABLE_GSX &&
                        architectureType === embLabels.PV_GENSET_ATS)
                        ? "Remote monitoring  / cloud      services"
                        : "EcoStruxure Microgrid Advisor cloud services"}
                         <Tooltip
                      position="top"
                      iconOption="raised"
                      iconColor="secondary"
                      iconSlot="tooltip"
                      information="Click on configure cloud services"
                    />
                    </span>
                      
                  </div>
                  <div className={`col-md-12 d-flex justify-content-center flex-column deploy-card-meta-block ${emaSiteId ? "deploy-version-min-height-36" : "deploy-version-empty-space"}`}>
                    { emaSiteId  &&(
                      <div className="row justify-content-start align-items-center deploy-site-id-row m-0">
                        <div className="col-3 pr-1 deploy-site-id-label">
                          <b>Site Id:</b>
                        </div>
                        <div className="col-9 p-0">
                          <input
                            type="text"
                            autoComplete="none"
                            className="form-control form-control-sm deploy-site-id-input"
                            value={emaSiteId}
                            title={emaSiteId}
                            readOnly
                          />
                        </div>
                      </div>
                    )}
                   {projectTypeValue === "NMGaaS ETO" &&
                      <div className="d-flex justify-content-end text-center configue-ema-link" >
                       <SeLink
                        href=""
                        title="Configure EMA Use Cases in Platform"
                        style={{
                          opacity: isConfigureUseCasesDisabled ? 0.45 : 1,
                          pointerEvents: isConfigureUseCasesDisabled ? "none" : "auto",
                          cursor: isConfigureUseCasesDisabled ? "not-allowed" : "pointer",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          if (isConfigureUseCasesDisabled) return;
                           navigateToEMOM();
                        }}
                          >
                            <span className="d-flex justify-content-center align-items-center">
                              <span className="pt-1">Configure EMA Use Cases &nbsp; </span>
                            <SeIcon>action_new_window</SeIcon>
                            </span>

                      </SeLink>
                      </div>
                      }
                  </div>
                    
                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                    <span
                      className={
                        [
                          embLabels.GRID_CONNECTED,
                          embLabels.ISLANDABLE,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                          ? // ? licenseMatched === "MATCHED" ? "dot-green": (keyExpert.expertExpired ? "dot-red": "dot-red")
                            licenseMatched === "MATCHED"
                            ? "dot-green"
                            : "dot-red"
                          : [
                              embLabels.PV_HYBRIDIZATION,
                              embLabels.ISLANDABLE_GSX,
                              embLabels.GENSET_PVBESS_A2E,
                            ].includes(siteType)
                          ? // ? (licenseMatched === "MATCHED"? "dot-green": keyOperations.operationExpired? "dot-red": "dot-red"): "dot-red"
                            licenseMatched === "MATCHED"
                            ? "dot-green"
                            : "dot-red"
                          : "dot-red"
                      }
                    ></span>

                    <span>
                      {[
                        embLabels.GRID_CONNECTED,
                        embLabels.ISLANDABLE,
                        embLabels.GRID_CONNECTED_GSX,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? " License key has been validated"
                          : licenseMatched === "NOT_MATCHED"
                          ? " License key is invalid"
                          : licenseMatched === "EXPIRED"
                          ? " License key has expired"
                          : " License key missing"
                        : [
                            embLabels.PV_HYBRIDIZATION,
                            embLabels.ISLANDABLE_GSX,
                            embLabels.GENSET_PVBESS_A2E,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? " License key has been validated"
                          : licenseMatched === "NOT_MATCHED"
                          ? " License key is invalid"
                          : licenseMatched === "EXPIRED"
                          ? " License key has expired"
                          : " License key missing"
                        : " License key missing"}
                    </span>
                  </div>
                  
                  <div className="col-md-12 d-flex justify-content-center deploy-card-footer-action">
                    {emaSiteStatus === false ? (
                      <se-button
                        size="small"
                        disabled={isConfigureEmaServicesDisabled}
                        onClick={createSiteInEMA}
                      >
                    {  projectTypeValue === "NMGaaS ETO" ? "Configure EMA Services": "Configure Cloud Services"}
                      </se-button>
                    ) : (
                   
                     <div className="d-flex flex-column justify-content-center ">
                    {projectTypeValue !== "NMGaaS ETO" && 
                    <se-button
                        size="small"
                        class={`${projectTypeValue === "NMGaaS ETO"?"ml-4 mr-4":""}`}
                        disabled={
                          projectProgressStatus?.projectStatus ===
                            "IN_PROGRESS" ||
                          UserScope.access.deleteSite === undefined
                            ? true
                            : licenseMatched === "MATCHED" ||
                              unlockDeploy ||
                              UserScope.access.unlockBypass === true ||
                              ([
                                embLabels.GRID_CONNECTED,
                                embLabels.ISLANDABLE,
                                embLabels.GRID_CONNECTED_GSX,
                              ].includes(siteType)
                                ? licenseMatched === "MATCHED"
                                : [
                                    embLabels.PV_HYBRIDIZATION,
                                    embLabels.ISLANDABLE_GSX,
                                    embLabels.GENSET_PVBESS_A2E,
                                  ].includes(siteType)
                                ? licenseMatched === "MATCHED"
                                : false)
                            ? false
                            : true
                        }
                        onClick={deleteSiteInEMA}
                      >
                        Delete Cloud Services
                      </se-button>}
                      
                       { projectTypeValue === "NMGaaS ETO" && 
                       <div className="d-flex justify-content-center align-items-center" style={{ gap: "8px", flexWrap: "nowrap" }}>
                       <se-button
                        size="small"
                        style={{ margin: 0 , paddingLeft: "8px", paddingRight: "8px", width:"200px"}}
                        disabled={isConfigureEmaServicesDisabled}
                        onClick={()=>createSiteInEMA("updated")}
                      >
                      {  "Update EMA site"}
                      </se-button>
                       {/* <se-button
                        size="small"
                        style={{ margin: 0 }}
                        color ="secondary"
                        disabled={true}
                        onClick={()=>{}}
                      >
                      {  "Delete site"}
                      </se-button> */}
                      <se-icon title="Delete EMA site"  onClick={deleteSiteInEMA} >action_delete</se-icon>
                      </div>
                    }
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {gridSetting.remoteMonitoringControl && (
              <div className={`col-md-3  padding-left remove-padding-right mt-2 mb-2`}>
                <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                  <div className="col-md-12 labelCircle-contanier">
                    <img
                      src={SEVIJEO}
                      className="img-fluid img-height-deploy"
                      alt="Deploy"
                    />
                    <span className="labelCircle-deploy">
                      {licenseMatched === "MATCHED" ||
                      unlockDeploy ||
                      ([
                        embLabels.ISLANDABLE,
                        embLabels.GRID_CONNECTED,
                        embLabels.GRID_CONNECTED_GSX,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : [
                            embLabels.PV_HYBRIDIZATION,
                            embLabels.ISLANDABLE_GSX,
                            embLabels.GENSET_PVBESS_A2E,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : false) ? (
                        <se-icon size="medium">action_lock_off</se-icon>
                      ) : (
                        <se-icon size="medium">action_lock_on</se-icon>
                      )}
                    </span>
                    <span
                      className="labelCircle-upload se-block-disabled"
                      onClick={() => {
                        const name =
                          siteType === embLabels.PV_HYBRIDIZATION ||
                          siteType === embLabels.GENSET_PVBESS_A2E ||
                          (siteType === embLabels.ISLANDABLE_GSX &&
                            architectureType === embLabels.PV_GENSET_ATS)
                            ? "Remote monitoring communication gateway / EMA controller"
                            : "EcoStruxure Microgrid Advisor Controller (Harmony iPC)";
                        openProgramModel(name, "EMA");
                        checkProgramFiles("IPC", false);
                      }}
                    >
                      {licenseMatched === "MATCHED" ||
                      unlockDeploy ||
                      ([
                        embLabels.ISLANDABLE,
                        embLabels.GRID_CONNECTED,
                        embLabels.GRID_CONNECTED_GSX,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : [
                            embLabels.PV_HYBRIDIZATION,
                            embLabels.ISLANDABLE_GSX,
                            embLabels.GENSET_PVBESS_A2E,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        :  false) ? (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      ) : (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      )}
                    </span>
                  </div>

                  <div className="col-md-12 deploy-card-title-block">
                    <span className="font-block-header">
                      {siteType === embLabels.PV_HYBRIDIZATION ||
                      siteType === embLabels.GENSET_PVBESS_A2E ||
                      (siteType === embLabels.ISLANDABLE_GSX &&
                        architectureType === embLabels.PV_GENSET_ATS)
                        ? "Remote monitoring communication gateway / EMA controller"
                        : "EcoStruxure Microgrid Advisor Controller (Harmony iPC)"}
                         <se-tooltip
                        action={isTouchDevice() ? "click" : "hover"}
                        position="top"
                      >
                        <se-icon
                          option="raised"
                          color="secondary"
                          size="small"
                          slot="tooltip"
                        >
                          information_circle
                        </se-icon>
                        <se-tooltip-content>
                          Download « .zip » configuration file on your computer
                          & import it into EMA controller Via EMA controller
                          interface.
                          <br></br>
                          <br></br>
                          For more details please refer to System Installation
                          Guide.
                        </se-tooltip-content>
                      </se-tooltip>
                    </span>
                    
                  </div>
                  <div className="col-md-12 deploy-version-empty-space deploy-card-meta-block"></div>
                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                    <span
                      className={
                        [
                          embLabels.GRID_CONNECTED,
                          embLabels.ISLANDABLE,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? "dot-green"
                            : "dot-red"
                          : // : keyExpert.expertExpired
                          // ? "dot-red"
                          // : "dot-red"
                          [
                              embLabels.PV_HYBRIDIZATION,
                              embLabels.ISLANDABLE_GSX,
                              embLabels.GENSET_PVBESS_A2E,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? "dot-green"
                            : "dot-red"
                          : // : keyOperations.operationExpired
                            // ? "dot-red"
                            // : "dot-red"
                            "dot-red"
                      }
                    ></span>
                    <span>
                      {[
                        embLabels.GRID_CONNECTED,
                        embLabels.ISLANDABLE,
                        embLabels.GRID_CONNECTED_GSX,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? " License key has been validated" // matched
                          : licenseMatched === "NOT_MATCHED"
                          ? " License key is invalid" //not matched
                          : licenseMatched === "EXPIRED"
                          ? " License key has expired" //
                          : " License key missing"
                        : [
                            embLabels.PV_HYBRIDIZATION,
                            embLabels.ISLANDABLE_GSX,
                            embLabels.GENSET_PVBESS_A2E,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? " License key has been validated"
                          : licenseMatched === "NOT_MATCHED"
                          ? " License key is invalid"
                          : licenseMatched === "EXPIRED"
                          ? " License key has expired"
                          : " License key missing"
                        : " License key missing"}
                    </span>
                  </div>
                  <div className="col-md-12 d-flex justify-content-center deploy-card-footer-action">
                    <div>
                      <div className=" ">
                        <se-button
                          disabled={enableButton()}
                          size="small"
                          // onClick={downloadIpcFile}
                          onClick={() =>{ 
                            if(emaSiteStatus === false){
                               setAlertMessage(
                                  `Alert`,
                                  false,
                                  ``,
                                  `Configure cloud services before downloading EMA controller configuration.`
                                );
                            }else{
                               checkProgramFiles("IPC", true);
                            }
                           
                          }}
                        >
                          Download Configuration{" "}
                          <se-icon size="dowloadIcon">action_download</se-icon>
                        </se-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className={`col-md-3  padding-left remove-padding-right mt-2 mb-2`}>
              <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                <div className="col-md-12 labelCircle-contanier">
                  <img
                    src={sePLC}
                    alt="PLC Project for Machine Expert"
                    className="img-fluid img-height-deploy"
                  />
                  <span className="labelCircle-deploy">
                    {licenseMatched === "MATCHED" ||
                    unlockDeploy ||
                    ([
                      embLabels.ISLANDABLE,
                      embLabels.PV_HYBRIDIZATION,
                      embLabels.ISLANDABLE_GSX,
                      embLabels.GENSET_PVBESS_A2E,
                    ].includes(siteType)
                      ? licenseMatched === "MATCHED"
                      : [
                          embLabels.GRID_CONNECTED,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                      ? licenseMatched === "MATCHED"
                      : false) ? (
                      <se-icon size="medium">action_lock_off</se-icon>
                    ) : (
                      <se-icon size="medium">action_lock_on</se-icon>
                    )}
                  </span>
                  <span
                    className={`labelCircle-upload ${
                      enableButton() ? "se-block-disabled" : ""
                    }`}
                    onClick={() => {
                      openProgramModel("EMOM", "PLC");
                      checkProgramFiles("PLC", false);
                    }}
                  >
                    {licenseMatched === "MATCHED" ||
                    unlockDeploy ||
                    ([
                      embLabels.ISLANDABLE,
                      embLabels.PV_HYBRIDIZATION,
                      embLabels.ISLANDABLE_GSX,
                      embLabels.GENSET_PVBESS_A2E,
                    ].includes(siteType)
                      ? licenseMatched === "MATCHED"
                      : [
                          embLabels.GRID_CONNECTED,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                      ? licenseMatched === "MATCHED"
                      :  false) ? (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      ) : (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                    )}

                  </span>
                </div>

                <div className="col-md-12 min-height-88 deploy-card-title-block deploy-plc-title-block">
                  <div className="deploy-plc-title-row">
                    <span className="font-block-header deploy-plc-title-text"
                    title={siteType === embLabels.GRID_CONNECTED
                        ? "M251 PLC Communication Gateway"
                        : "EcoStruxure Microgrid Operation Medium Controller (M251 PLC)"}
                    >
                      {siteType === embLabels.GRID_CONNECTED
                        ? "M251 PLC Communication Gateway"
                        : "EcoStruxure Microgrid Operation Medium Controller (M251 PLC)"}
                    </span>
                    <span className="deploy-plc-title-tooltip">
                      <se-tooltip
                      action={isTouchDevice() ? "click" : "hover"}
                      position="right"
                    >
                      <se-icon
                        option="raised"
                        color="secondary"
                        size="small"
                        slot="tooltip"
                      >
                        information_circle
                      </se-icon>
                      <se-tooltip-content>
                        <p>
                          1. Download ".zip" file on your computer
                          <br></br>
                          <br></br>
                          2. Unzip in a selected folder
                          <br></br>
                          <br></br>
                          3. Open EcoStruxure Machine Expert Tool
                          <br></br>
                          <br></br>
                          4. Open .py file :<br></br>
                          In Ecostuxure machine tool click on
                          "tools/scripting/execute script file"
                          <br></br>
                          Select ".py" file in the unziped folder
                          <br></br>
                          Execute
                          <br></br>⇒ the application automatically built
                          <br></br>
                          <br></br>
                          5. Build the program in EME by clicking on
                          "Build/build"
                          <br></br>
                          <br></br>
                          6. Transfer the program to the controller with USB
                          interface. (use BMXCAUSB018 cable)
                          <br></br>
                          Click on "online/login". Select the controller
                          detected.
                          <br></br>
                          <br></br>
                          For more details please refer to System Installation
                          Guide.
                        </p>
                      </se-tooltip-content>
                    </se-tooltip>
                    </span>
                  </div>
                </div>

                <div className="col-md-12 deploy-version-min-height-36 deploy-card-meta-block">
                  <div c>
                    EcoStruxure Machine Expert version {versions.plcVersion}
                  </div>
                  <div className="d-flex justify-content-center text-center configue-ema-link">
                    {emoDocList && Object?.entries(emoDocList).length > 0 && (
                      <SeLink
                        className="deploy-centered-meta-link"
                        href=""
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          setShowConfig(true);
                        }}
                      >
                        <span className="d-flex justify-content-center align-items-center">
                          <span className="pt-1">EMO-M I/O Configuration&nbsp;</span>
                          <SeIcon>action_layer_forward</SeIcon>
                        </span>
                      </SeLink>
                    )}
                  </div>
                </div>
                <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                  <span
                    className={
                      [
                        embLabels.GRID_CONNECTED,
                        embLabels.GRID_CONNECTED_GSX,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? "dot-green"
                          : "dot-red"
                        : // : keyExpert.expertExpired
                        // ? "dot-red"
                        // : "dot-red"
                        [
                            embLabels.ISLANDABLE,
                            embLabels.PV_HYBRIDIZATION,
                            embLabels.ISLANDABLE_GSX,
                            embLabels.GENSET_PVBESS_A2E,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? "dot-green"
                          : "dot-red"
                        : // : keyOperations.operationExpired
                          // ? "dot-red"
                          // : "dot-red"
                          "dot-red"
                    }
                  ></span>
                  <span>
                    {[
                      embLabels.GRID_CONNECTED,
                      embLabels.GRID_CONNECTED_GSX,
                    ].includes(siteType)
                      ? licenseMatched === "MATCHED"
                        ? " License key has been validated"
                        : licenseMatched === "NOT_MATCHED"
                        ? " License key is invalid"
                        : licenseMatched === "EXPIRED"
                        ? " License key has expired"
                        : " License key missing"
                      : [
                          embLabels.PV_HYBRIDIZATION,
                          embLabels.ISLANDABLE,
                          embLabels.ISLANDABLE_GSX,
                          embLabels.GENSET_PVBESS_A2E,
                        ].includes(siteType)
                      ? licenseMatched === "MATCHED"
                        ? " License key has been validated"
                        : licenseMatched === "NOT_MATCHED"
                        ? " License key is invalid"
                        : licenseMatched === "EXPIRED"
                        ? " License key has expired"
                        : " License key missing"
                      : " License key missing"}
                  </span>
                </div>
                <div className="col-md-12 deploy-card-footer-action">
                  <div className="col-md-12 d-flex justify-content-center ">
                    <div>
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        // onClick={handleSerialNoPopUp}
                        onClick={() => checkProgramFiles("PLC", true)}
                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {gridSetting.userInterface === false ||
            (clientType === embLabels.GENERIC_PROJECT &&
              siteType === embLabels.GRID_CONNECTED &&
              gridSetting.userInterface === false) ||
            (siteType === embLabels.GRID_CONNECTED_GSX &&
              architectureType === embLabels.PV_BESS_NR &&
              gridSetting.userInterface === false) ||
            (siteType === embLabels.ISLANDABLE_GSX &&
              architectureType === embLabels.PV_GENSET_ATS &&
              gridSetting.userInterface === false) ||
            (clientType === embLabels.A2E_PROJECT &&
              siteType === embLabels.GENSET_PVBESS_A2E &&
              !gridSetting.userInterface) ? (
              ""
            ) : (
              <div className={`col-md-3  padding-left remove-padding-right mt-2 mb-2`}>
                <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                  <div className="col-md-12 labelCircle-contanier">
                    <img
                      src={seVijeo}
                      alt="Download"
                      className="img-fluid img-height-deploy"
                    />
                    <span className="labelCircle-deploy">
                      {unlockDeploy || licenseMatched === "MATCHED" ? (
                        <se-icon size="medium">action_lock_off</se-icon>
                      ) : (
                        <se-icon size="medium">action_lock_on</se-icon>
                      )}
                    </span>
                    <span
                      className="labelCircle-upload se-block-disabled"
                      onClick={() => {
                        openProgramModel("HMI", "HMI");
                        checkProgramFiles("HMI", false);
                      }}
                    >
                       {unlockDeploy || licenseMatched === "MATCHED" ? (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      ) : (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      )}

                    </span>
                  </div>

                  <div className="col-md-12 min-height-100 deploy-card-title-block">
                    <span className="font-block-header">
                      EcoStruxure Microgrid Operation Medium HMI (Magelis HMI)
                       <se-tooltip
                        action={isTouchDevice() ? "click" : "hover"}
                        position="left"
                      >
                        <se-icon
                          option="raised"
                          color="secondary"
                          size="small"
                          slot="tooltip"
                        >
                          information_circle
                        </se-icon>
                        <se-tooltip-content>
                          <span>{parseTooltipContent()}</span>
                       </se-tooltip-content>
                      </se-tooltip>
                    </span>
                  </div>

                  <div className="col-md-12 deploy-version-min-height-36 deploy-card-meta-block">
                    {/* <span>Vijeo designer version {versions.hmiVersion}</span> */}
                    <span>
                      EcoStruxure Operator Terminal Expert SP{" "}
                      {versions.hmiVersion}
                    </span>
                  </div>
                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                    <span
                      className={
                        licenseMatched === "MATCHED" ? "dot-green" : "dot-red"
                        // : keyOperations.operationExpired
                        // ? "dot-red"
                        // : "dot-red"
                      }
                    ></span>
                    <span>
                      {licenseMatched === "MATCHED"
                        ? " License key has been validated"
                        : licenseMatched === "NOT_MATCHED"
                        ? " License key is invalid"
                        : licenseMatched === "EXPIRED"
                        ? " License key has expired"
                        : " License key missing"}
                    </span>
                  </div>
                  <div className="col-md-12 deploy-card-footer-action">
                    <div className="col-md-12 d-flex justify-content-center">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        // onClick={downloadHMI}
                        onClick={() => checkProgramFiles("HMI", true)}
                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {(bessControllerAvailable || masterBessControllerAvailable) && <>
              <div className={`col-md-3 pt-1`}>
                <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                  <div className="col-md-12 labelCircle-contanier">
                    <img
                      src={batteryImage}
                      alt="Download"
                      className="img-fluid img-height-deploy"
                    />
                  </div>

                  <div className="col-md-12 min-height-100 deploy-card-title-block">
                    <span className="font-block-header">
                      Schneider Electric BESS Controller
                    </span>
                    <span className="se-block-enabled">
                      {/* <se-tooltip
                        action={isTouchDevice() ? "click" : "hover"}
                        position="left"
                      >
                        <se-icon
                          option="raised"
                          color="secondary"
                          size="small"
                          slot="tooltip"
                        >
                          information_circle
                        </se-icon>
                        <se-tooltip-content>
                        <span dangerouslySetInnerHTML={{ __html: toolTipData?.tooltipData?.seBessController?.data}} />
                        </se-tooltip-content>
                      </se-tooltip> */}
                    </span>
                  </div>

                  <div className="col-md-12 deploy-version-min-height-36 deploy-card-meta-block">
                    {/* <span>Vijeo designer version {versions.hmiVersion}</span> */}
                    <span>
                      BESS Controller Software Package V{latestVersionMap?.["BESS controller"]}
                      {/* {versions.seBessControllerVersion} */}
                    </span>
                  </div>
                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">

                  </div>
                  <div className="col-md-12 deploy-card-footer-action">
                    <div className="col-md-12 d-flex justify-content-center">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        onClick={() => downloadBESSController("BESS controller")}

                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`col-md-3 pt-1`}>
                <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                  <div className="col-md-12 labelCircle-contanier">
                    <img
                      src={seVijeo}
                      alt="Download"
                      className="img-fluid img-height-deploy"
                    />
                  </div>

                  <div className="col-md-12 min-height-100 deploy-card-title-block">
                    <span className="font-block-header">
                      Schneider Electric BESS Controller HMI
                    </span>
                    <span className="se-block-enabled">
                      {/* <se-tooltip
                        action={isTouchDevice() ? "click" : "hover"}
                        position="left"
                      >
                        <se-icon
                          option="raised"
                          color="secondary"
                          size="small"
                          slot="tooltip"
                        >
                          information_circle
                        </se-icon>
                        <se-tooltip-content>
                        <span dangerouslySetInnerHTML={{ __html: toolTipData?.tooltipData?.seBessControllerHmi?.data}} />
                        </se-tooltip-content>
                      </se-tooltip> */}
                    </span>
                  </div>

                  <div className="col-md-12 deploy-version-min-height-36 deploy-card-meta-block">
                    {/* <span>Vijeo designer version {versions.hmiVersion}</span> */}
                    <span>
                      SE BESS Controller HMI Software Package V{latestVersionMap?.["BESS controller HMI"]}
                      {/* {versions.seBessControllerHmiVersion} */}
                    </span>
                  </div>
                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">

                  </div>
                  <div className="col-md-12 deploy-card-footer-action">
                    <div className="col-md-12 d-flex justify-content-center">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        onClick={() => downloadBESSController("BESS controller HMI")}

                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              </div>

            </>}

            {masterBessControllerAvailable && <>
              <div className={`col-md-3 pt-1`}>
                <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                  <div className="col-md-12 labelCircle-contanier">
                    <img
                      src={batteryImage}
                      alt="Download"
                      className="img-fluid img-height-deploy"
                    />
                  </div>

                  <div className="col-md-12 min-height-100 deploy-card-title-block">
                    <span className="font-block-header">
                      Master Electric BESS Controller
                    </span>
                    <span className="se-block-enabled">
                      {/* <se-tooltip
                        action={isTouchDevice() ? "click" : "hover"}
                        position="left"
                      >
                        <se-icon
                          option="raised"
                          color="secondary"
                          size="small"
                          slot="tooltip"
                        >
                          information_circle
                        </se-icon>
                        <se-tooltip-content>
                        <span dangerouslySetInnerHTML={{ __html: toolTipData?.tooltipData?.seBessController?.data}} />
                        </se-tooltip-content>
                      </se-tooltip> */}
                    </span>
                  </div>

                  <div className="col-md-12 deploy-version-min-height-36 deploy-card-meta-block">
                    {/* <span>Vijeo designer version {versions.hmiVersion}</span> */}
                    <span>
                      Master BESS Controller Software Package V{latestVersionMap?.["Master BESS controller"]}
                      {/* {versions.seBessControllerVersion} */}
                    </span>
                  </div>
                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">

                  </div>
                  <div className="col-md-12 deploy-card-footer-action">
                    <div className="col-md-12 d-flex justify-content-center">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        onClick={() => downloadBESSController("Master BESS controller")}

                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              </div>

              <div className={`col-md-3 pt-1`}>
                <div className="row deploy-border padding-1px se-white-background deploy-card-min-height ml-1 deploy-card-shell">
                  <div className="col-md-12 labelCircle-contanier">
                    <img
                      src={seVijeo}
                      alt="Download"
                      className="img-fluid img-height-deploy"
                    />
                  </div>

                  <div className="col-md-12 min-height-100 deploy-card-title-block">
                    <span className="font-block-header">
                      Master Electric BESS Controller HMI
                    </span>
                    <span className="se-block-enabled">
                      {/* <se-tooltip
                        action={isTouchDevice() ? "click" : "hover"}
                        position="left"
                      >
                        <se-icon
                          option="raised"
                          color="secondary"
                          size="small"
                          slot="tooltip"
                        >
                          information_circle
                        </se-icon>
                        <se-tooltip-content>
                        <span dangerouslySetInnerHTML={{ __html: toolTipData?.tooltipData?.seBessControllerHmi?.data}} />
                        </se-tooltip-content>
                      </se-tooltip> */}
                    </span>
                  </div>

                  <div className="col-md-12 deploy-version-min-height-36 deploy-card-meta-block">
                    {/* <span>Vijeo designer version {versions.hmiVersion}</span> */}
                    <span>
                      SE BESS Controller HMI Software Package V{latestVersionMap?.["Master BESS controller HMI"]}
                      {/* {versions.seBessControllerHmiVersion} */}
                    </span>
                  </div>
                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">

                  </div>
                  <div className="col-md-12 deploy-card-footer-action">
                    <div className="col-md-12 d-flex justify-content-center">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        onClick={() => downloadBESSController("Master BESS controller HMI")}

                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              </div>

            </>}
          </div>
        </div>
      </div>
      {!["IEC | AccessToEnergy | Microgrid Advisor",].includes(
        projectProgressStatus?.projectType
      ) ? (
        <div className="row mt-2">
          <div className="col-sm-12 mb-2 se-life-green se-font-14px-bold mt-2 mb-2 pl-0">
            Secure Communication Configuration
          </div>

          <div className="col-sm-12">
            <div className="row justify-content-center deploy-row-equal-height">
              {gatewayType === "moxa" && (
                <div className="col-md-3 padding-left remove-padding-right mt-2 mb-2">
                  <div className="deploy-border padding-1px se-white-background deploy-card-min-height-400 deploy-card-shell secure-comm-card">
                    <div className="labelCircle-contanier">
                      <img
                        // src={moxa}
                        src={MOXA}
                        alt="Moxa PLC Project for Machine Expert"
                        className="img-fluid img-height-deploy"
                      />
                      <span className="labelCircle-deploy">
                        {licenseMatched === "MATCHED" ||
                        unlockDeploy ||
                        ([
                          embLabels.ISLANDABLE,
                          embLabels.PV_HYBRIDIZATION,
                          embLabels.ISLANDABLE_GSX,
                          embLabels.GENSET_PVBESS_A2E,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : [
                              embLabels.GRID_CONNECTED,
                              embLabels.GRID_CONNECTED_GSX,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : false) ? (
                          <se-icon size="medium">action_lock_off</se-icon>
                        ) : (
                          <se-icon size="medium">action_lock_on</se-icon>
                        )}
                      </span>
                      <span
                        className="labelCircle-upload se-block-disabled"
                        onClick={() => {
                          openProgramModel("Moxa", "MOXA");
                          checkProgramFiles("MOXA", false);
                        }}
                      >
                        {licenseMatched === "MATCHED" ||
                        unlockDeploy ||
                        ([
                          embLabels.ISLANDABLE,
                          embLabels.PV_HYBRIDIZATION,
                          embLabels.ISLANDABLE_GSX,
                          embLabels.GENSET_PVBESS_A2E,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : [
                              embLabels.GRID_CONNECTED,
                              embLabels.GRID_CONNECTED_GSX,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          :  false) ? (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      ) : (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                        )}
                      </span>
                    </div>

                    <div className="col-md-12 min-height-66 deploy-card-title-block">
                      {true ? (
                        <span className="font-block-header">
                          Moxa Communication Gateway
                        </span>
                      ) : (
                        <span className="font-block-header">
                          <span className="font-block-header">
                            Moxa Secure Communication - Architecture
                          </span>
                        </span>
                      )}
                      <span className="se-block-enabled">
                        <se-tooltip
                          action={isTouchDevice() ? "click" : "hover"}
                          position="right"
                        >
                          <se-icon
                            option="raised"
                            color="secondary"
                            size="small"
                            slot="tooltip"
                          >
                            information_circle
                          </se-icon>
                          <se-tooltip-content>
                            <p>
                              1. Download “ini file” on the computer. Connect to
                              MOXA GUI using a browser.
                              <br></br>
                              <br></br>
                              2. Click on System <span>&#8594;</span> System
                              File Update <span>&#8594;</span> Local
                              Import/Export use “Import text-based configuration
                              file” option
                              <br></br>
                              <br></br>
                              3. Click Choose File to select the configuration
                              file from the computer and click the Apply button
                              <br></br>
                              <br></br>
                              For more details please refer to System
                              Installation Guide.
                            </p>
                          </se-tooltip-content>
                        </se-tooltip>
                      </span>
                    </div>

                    <div className="col-md-12 deploy-version-empty-space deploy-card-meta-block">
                      <span className="d-none">
                        EcoStruxure Machine Expert version {versions.plcVersion}
                      </span>
                    </div>

                    <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                      <span
                        className={
                          [
                            embLabels.GRID_CONNECTED,
                            embLabels.GRID_CONNECTED_GSX,
                          ].includes(siteType)
                            ? licenseMatched === "MATCHED"
                              ? "dot-green"
                              : "dot-red"
                            : // : keyExpert.expertExpired
                            // ? "dot-red"
                            // : "dot-red"
                            [
                                embLabels.ISLANDABLE,
                                embLabels.PV_HYBRIDIZATION,
                                embLabels.ISLANDABLE_GSX,
                                embLabels.GENSET_PVBESS_A2E,
                              ].includes(siteType)
                            ? licenseMatched === "MATCHED"
                              ? "dot-green"
                              : "dot-red"
                            : // : keyOperations.operationExpired
                              // ? "dot-red"
                              // : "dot-red"
                              "dot-red"
                        }
                      ></span>
                      <span>
                        {[
                          embLabels.GRID_CONNECTED,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? " License key has been validated"
                            : licenseMatched === "NOT_MATCHED"
                            ? " License key is invalid"
                            : licenseMatched === "EXPIRED"
                            ? " License key has expired"
                            : " License key missing"
                          : [
                              embLabels.PV_HYBRIDIZATION,
                              embLabels.ISLANDABLE,
                              embLabels.ISLANDABLE_GSX,
                              embLabels.GENSET_PVBESS_A2E,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? " License key has been validated"
                            : licenseMatched === "NOT_MATCHED"
                            ? " License key is invalid"
                            : licenseMatched === "EXPIRED"
                            ? " License key has expired"
                            : " License key missing"
                          : " License key missing"}
                      </span>
                    </div>

                    <div className="col-md-12 d-flex justify-content-center deploy-card-footer-action">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        // onClick={downloadMOXA}
                        onClick={() => checkProgramFiles("MOXA", true)}
                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              )}

              {gatewayType === "fortigate" && (
                <div className="col-md-3 padding-left remove-padding-right mt-2 mb-2">
                  <div className="deploy-border padding-1px se-white-background deploy-card-min-height-400 deploy-card-shell secure-comm-card">
                    <div className="labelCircle-contanier">
                      <img
                        src={Fortigate}
                        alt="FortiGate PLC Project for Machine Expert"
                        className="img-fluid img-height-deploy fortigate-image-boost"
                      />
                      <span className="labelCircle-deploy">
                        {licenseMatched === "MATCHED" ||
                        unlockDeploy ||
                        ([
                          embLabels.ISLANDABLE,
                          embLabels.PV_HYBRIDIZATION,
                          embLabels.ISLANDABLE_GSX,
                          embLabels.GENSET_PVBESS_A2E,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : [
                              embLabels.GRID_CONNECTED,
                              embLabels.GRID_CONNECTED_GSX,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : false) ? (
                          <se-icon size="medium">action_lock_off</se-icon>
                        ) : (
                          <se-icon size="medium">action_lock_on</se-icon>
                        )}
                      </span>
                      <span
                        className="labelCircle-upload se-block-disabled"
                        onClick={() => {
                          openProgramModel("FortiGate", "FortiGate");
                          checkProgramFiles("FortiGate", false);
                        }}
                      >
                        {licenseMatched === "MATCHED" ||
                        unlockDeploy ||
                        ([
                          embLabels.ISLANDABLE,
                          embLabels.PV_HYBRIDIZATION,
                          embLabels.ISLANDABLE_GSX,
                          embLabels.GENSET_PVBESS_A2E,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : [
                              embLabels.GRID_CONNECTED,
                              embLabels.GRID_CONNECTED_GSX,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                         :false) ? (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      ) : (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                        )}
                      </span>
                    </div>

                    <div className="col-md-12 min-height-77 deploy-card-title-block">
                      {true ? (
                        <span className="font-block-header">
                          FortiGate Communication Gateway
                        </span>
                      ) : (
                        <span className="font-block-header">
                          <span className="font-block-header">
                            FortiGate Secure Communication - Architecture
                          </span>
                        </span>
                      )}
                      <span className="se-block-enabled">
                        <se-tooltip
                          action={isTouchDevice() ? "click" : "hover"}
                          position="right"
                        >
                          <se-icon
                            option="raised"
                            color="secondary"
                            size="small"
                            slot="tooltip"
                          >
                            information_circle
                          </se-icon>
                          <se-tooltip-content>
                            <p>
                              1. Download “ini file” on the computer. Connect to
                              FortiGate GUI using a browser.
                              <br></br>
                              <br></br>
                              2. Click on System <span>&#8594;</span> System
                              File Update <span>&#8594;</span> Local
                              Import/Export use “Import text-based configuration
                              file” option
                              <br></br>
                              <br></br>
                              3. Click Choose File to select the configuration
                              file from the computer and click the Apply button
                              <br></br>
                              <br></br>
                              For more details please refer to System
                              Installation Guide.
                            </p>
                          </se-tooltip-content>
                        </se-tooltip>
                      </span>
                    </div>

                    <div className="col-md-12 deploy-version-empty-space deploy-card-meta-block">
                      <span className="d-none">
                        EcoStruxure Machine Expert version {versions.plcVersion}
                      </span>
                    </div>

                    <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                      <span
                        className={
                          [
                            embLabels.GRID_CONNECTED,
                            embLabels.GRID_CONNECTED_GSX,
                          ].includes(siteType)
                            ? licenseMatched === "MATCHED"
                              ? "dot-green"
                              : "dot-red"
                            : // : keyExpert.expertExpired
                            // ? "dot-red"
                            // : "dot-red"
                            [
                                embLabels.ISLANDABLE,
                                embLabels.PV_HYBRIDIZATION,
                                embLabels.ISLANDABLE_GSX,
                                embLabels.GENSET_PVBESS_A2E,
                              ].includes(siteType)
                            ? licenseMatched === "MATCHED"
                              ? "dot-green"
                              : "dot-red"
                            : // : keyOperations.operationExpired
                              // ? "dot-red"
                              // : "dot-red"
                              "dot-red"
                        }
                      ></span>
                      <span>
                        {[
                          embLabels.GRID_CONNECTED,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? " License key has been validated"
                            : licenseMatched === "NOT_MATCHED"
                            ? " License key is invalid"
                            : licenseMatched === "EXPIRED"
                            ? " License key has expired"
                            : " License key missing"
                          : [
                              embLabels.PV_HYBRIDIZATION,
                              embLabels.ISLANDABLE,
                              embLabels.ISLANDABLE_GSX,
                              embLabels.GENSET_PVBESS_A2E,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? " License key has been validated"
                            : licenseMatched === "NOT_MATCHED"
                            ? " License key is invalid"
                            : licenseMatched === "EXPIRED"
                            ? " License key has expired"
                            : " License key missing"
                          : " License key missing"}
                      </span>
                    </div>

                    <div className="col-md-12 d-flex justify-content-center deploy-card-footer-action">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        // onClick={downloadMOXA}
                        onClick={() => checkProgramFiles("FortiGate", true)}
                      >
                        Download Program{" "}
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-md-3 padding-left remove-padding-right mt-2 mb-2">
                <div className="deploy-border padding-1px se-white-background deploy-card-min-height-400 deploy-card-shell secure-comm-card">
                  <div className="labelCircle-contanier">
                    <img
                      src={connexium}
                      alt="Moxa PLC Project for Machine Expert"
                      className="img-fluid img-height-deploy"
                    />
                    <span className="labelCircle-deploy">
                      {licenseMatched === "MATCHED" ||
                      unlockDeploy ||
                      ([
                        embLabels.ISLANDABLE,
                        embLabels.PV_HYBRIDIZATION,
                        embLabels.ISLANDABLE_GSX,
                        embLabels.GENSET_PVBESS_A2E,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : [
                            embLabels.GRID_CONNECTED,
                            embLabels.GRID_CONNECTED_GSX,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : false) ? (
                        <se-icon size="medium">action_lock_off</se-icon>
                      ) : (
                        <se-icon size="medium">action_lock_on</se-icon>
                      )}
                    </span>
                    <span
                      className="labelCircle-upload se-block-disabled"
                      onClick={() => {
                        openProgramModel("ConneXium", "CONNEXIUM");
                        checkProgramFiles("CONNEXIUM", false);
                      }}
                    >
                      {licenseMatched === "MATCHED" ||
                      unlockDeploy ||
                      ([
                        embLabels.ISLANDABLE,
                        embLabels.PV_HYBRIDIZATION,
                        embLabels.ISLANDABLE_GSX,
                        embLabels.GENSET_PVBESS_A2E,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        : [
                            embLabels.GRID_CONNECTED,
                            embLabels.GRID_CONNECTED_GSX,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                        :  false) ? (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      ) : (
                        <se-icon size="medium">action_upload_stroke</se-icon>
                      )}
                    </span>
                  </div>

                  <div className="col-md-12 min-height-77 deploy-card-title-block">
                    {siteType === embLabels.GRID_CONNECTED ? (
                      <span className="font-block-header">
                        ConneXium PLC Communication Gateway
                      </span>
                    ) : (
                      <span className="font-block-header">
                        <span className="font-block-header">
                          ConneXium Secure Communication Architecture for
                          Modicon Managed Switch
                        </span>
                      </span>
                    )}
                    <span className="se-block-enabled">
                      <se-tooltip
                        action={isTouchDevice() ? "click" : "hover"}
                        position="right"
                      >
                        <se-icon
                          option="raised"
                          color="secondary"
                          size="small"
                          slot="tooltip"
                        >
                          information_circle
                        </se-icon>
                        <se-tooltip-content>
                          {/* <p>
                          1. Download ".zip" file on your computer
                          <br></br>
                          <br></br>
                          2. Unzip in a selected folder
                          <br></br>
                          <br></br>
                          3. Open EcoStruxure Machine Expert Tool
                          <br></br>
                          <br></br>
                          4. Open .py file :<br></br>
                          In EcoStruxure machine tool click on
                          "tools/scripting/execute script file"
                          <br></br>
                          Select ".py" file in the unziped folder
                          <br></br>
                          Execute
                          <br></br>⇒ the application automatically built
                          <br></br>
                          <br></br>
                          5. Build the program in EME by clicking on
                          "Build/build"
                          <br></br>
                          <br></br>
                          6. Transfer the program to the controller with USB
                          interface. (use BMXCAUSB018 cable)
                          <br></br>
                          Click on "online/login". Select the controller
                          detected.
                          <br></br>
                          <br></br>
                          For more details please refer to System Installation
                          Guide.
                        </p> */}
                          <p>
                            1. Download “cli file” on the computer
                            <br></br>
                            <br></br>
                            2. Connect to Modicon GUI using a browser.
                            <br></br>
                            <br></br>
                            3. Load the file.
                            <br></br>
                            <br></br>
                            For more details please refer to System Installation
                            Guide.
                          </p>
                        </se-tooltip-content>
                      </se-tooltip>
                    </span>
                  </div>

                  <div className="col-md-12 deploy-version-empty-space deploy-card-meta-block">
                    <span className="d-none">
                      EcoStruxure Machine Expert version {versions.plcVersion}
                    </span>
                  </div>

                  <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                    <span
                      className={
                        [
                          embLabels.GRID_CONNECTED,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? "dot-green"
                            : "dot-red"
                          : // : keyExpert.expertExpired
                          // ? "dot-red"
                          // : "dot-red"
                          [
                              embLabels.ISLANDABLE,
                              embLabels.PV_HYBRIDIZATION,
                              embLabels.ISLANDABLE_GSX,
                              embLabels.GENSET_PVBESS_A2E,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? "dot-green"
                            : "dot-red"
                          : // : keyOperations.operationExpired
                            // ? "dot-red"
                            // : "dot-red"
                            "dot-red"
                      }
                    ></span>
                    <span>
                      {[
                        embLabels.GRID_CONNECTED,
                        embLabels.GRID_CONNECTED_GSX,
                      ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? " License key has been validated"
                          : licenseMatched === "NOT_MATCHED"
                          ? " License key is invalid"
                          : licenseMatched === "EXPIRED"
                          ? " License key has expired"
                          : " License key missing"
                        : [
                            embLabels.PV_HYBRIDIZATION,
                            embLabels.ISLANDABLE,
                            embLabels.ISLANDABLE_GSX,
                            embLabels.GENSET_PVBESS_A2E,
                          ].includes(siteType)
                        ? licenseMatched === "MATCHED"
                          ? " License key has been validated"
                          : licenseMatched === "NOT_MATCHED"
                          ? " License key is invalid"
                          : licenseMatched === "EXPIRED"
                          ? " License key has expired"
                          : " License key missing"
                        : " License key missing"}
                    </span>
                  </div>

                  <div className="col-md-12 d-flex justify-content-center deploy-card-footer-action">
                    <se-button
                      size="small"
                      disabled={enableButton()}
                      // onClick={downloadCONNEXIUM}
                      onClick={() => checkProgramFiles("CONNEXIUM", true)}
                    >
                      Download Program{" "}
                      <se-icon size="dowloadIcon">action_download</se-icon>
                    </se-button>
                  </div>
                </div>
              </div>
              {(env?.REACT_APP_ENABLED_ON_LOGIC?.includes(projectTypeValue)) && (
                <div className="col-md-3 padding-left remove-padding-right mt-2 mb-2 ">
                  <div className="deploy-border padding-1px se-white-background deploy-card-min-height-400 deploy-card-shell secure-comm-card">
                    <div className="labelCircle-contanier d-flex justify-content-center">
                      <img
                        src={ONLOGIC}
                        alt="Onlogic"
                        className="img-fluid img-height-deploy onlogic-image-narrow"
                      />
                      <span className="labelCircle-deploy">
                        {licenseMatched === "MATCHED" ||
                        unlockDeploy ||
                        ([
                          embLabels.ISLANDABLE,
                          embLabels.PV_HYBRIDIZATION,
                          embLabels.ISLANDABLE_GSX,
                          embLabels.GENSET_PVBESS_A2E,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : [
                              embLabels.GRID_CONNECTED,
                              embLabels.GRID_CONNECTED_GSX,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                          : false) ? (
                          <se-icon size="medium">action_lock_off</se-icon>
                        ) : (
                          <se-icon size="medium">action_lock_on</se-icon>
                        )}
                      </span>
                    </div>

                    <div className="col-md-12 min-height-77 deploy-card-title-block">
                      <span className="font-block-header">
                        <span className="font-block-header">
                          {
                            "OnLogic Factor 201 Raspberry Pi Industrial IoT Gateway"
                          }
                        </span>
                      </span>
                      <span className="se-block-enabled">
                        <se-tooltip
                          action={isTouchDevice() ? "click" : "hover"}
                          position="right"
                        >
                          <se-icon
                            option="raised"
                            color="secondary"
                            size="small"
                            slot="tooltip"
                          >
                            information_circle
                          </se-icon>
                          <se-tooltip-content>
                            {
                              "OnLogic Factor 201 Raspberry Pi Industrial IoT Gateway"
                            }
                          </se-tooltip-content>
                        </se-tooltip>
                      </span>
                    </div>

                    <div className="col-md-12 deploy-version-empty-space deploy-card-meta-block">
                      <span className="d-none"></span>
                    </div>

                    <div className="col-md-12 d-flex align-items-center deploy-card-footer-license">
                      <span
                        className={
                          [
                            embLabels.GRID_CONNECTED,
                            embLabels.GRID_CONNECTED_GSX,
                          ].includes(siteType)
                            ? licenseMatched === "MATCHED"
                              ? "dot-green"
                              : "dot-red"
                            : // : keyExpert.expertExpired
                            // ? "dot-red"
                            // : "dot-red"
                            [
                                embLabels.ISLANDABLE,
                                embLabels.PV_HYBRIDIZATION,
                                embLabels.ISLANDABLE_GSX,
                                embLabels.GENSET_PVBESS_A2E,
                              ].includes(siteType)
                            ? licenseMatched === "MATCHED"
                              ? "dot-green"
                              : "dot-red"
                            : // : keyOperations.operationExpired
                              // ? "dot-red"
                              // : "dot-red"
                              "dot-red"
                        }
                      ></span>
                      <span>
                        {[
                          embLabels.GRID_CONNECTED,
                          embLabels.GRID_CONNECTED_GSX,
                        ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? " License key has been validated"
                            : licenseMatched === "NOT_MATCHED"
                            ? " License key is invalid"
                            : licenseMatched === "EXPIRED"
                            ? " License key has expired"
                            : " License key missing"
                          : [
                              embLabels.PV_HYBRIDIZATION,
                              embLabels.ISLANDABLE,
                              embLabels.ISLANDABLE_GSX,
                              embLabels.GENSET_PVBESS_A2E,
                            ].includes(siteType)
                          ? licenseMatched === "MATCHED"
                            ? " License key has been validated"
                            : licenseMatched === "NOT_MATCHED"
                            ? " License key is invalid"
                            : licenseMatched === "EXPIRED"
                            ? " License key has expired"
                            : " License key missing"
                          : " License key missing"}
                      </span>
                    </div>

                    <div className="col-md-12 d-flex justify-content-center deploy-card-footer-action">
                      <se-button
                        size="small"
                        disabled={enableButton()}
                        onClick={downloadOnLogic}
                      >
                        Download Program
                        <se-icon size="dowloadIcon">action_download</se-icon>
                      </se-button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Services;
